module.exports = __webpack_public_path__ + "common/icon-cart-gray-bdb9731491cb0dc12f11ccd064fc82e2.svg";